import {
    collection,
    addDoc,
    doc,
    updateDoc,
    deleteDoc,
    onSnapshot,
    query,
    where,
    serverTimestamp,
} from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { firestore, storage } from '_utils/firebase-app';

const COLLECTION = 'archive';

export const createArchive = async (data) => {
    const collectionRef = collection(firestore, COLLECTION);
    const docRef = await addDoc(collectionRef, {
        ...data,
        attachments: data.attachments ?? [],
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
    });
    return docRef.id;
};

export const uploadAttachment = (archiveId, file, uploader) => {
    return new Promise((resolve, reject) => {
        const fileId = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
        const storagePath = `archive/${archiveId}/${fileId}-${file.name}`;
        const storageRef = ref(storage, storagePath);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on(
            'state_changed',
            null,
            (error) => reject(error),
            async () => {
                const downloadUrl = await getDownloadURL(uploadTask.snapshot.ref);
                resolve({
                    id: fileId,
                    filename: file.name,
                    contentType: file.type,
                    size: file.size,
                    storagePath,
                    downloadUrl,
                    uploadedBy: { ...uploader, source: 'portal' },
                    uploadedAt: new Date().toISOString(),
                });
            }
        );
    });
};

export const appendAttachments = async (archiveId, newAttachments, existingAttachments = []) => {
    const docRef = doc(firestore, COLLECTION, archiveId);
    await updateDoc(docRef, {
        attachments: [...existingAttachments, ...newAttachments],
        updatedAt: serverTimestamp(),
    });
};

export const subscribeToArchives = (iata, callback) => {
    // Filter by iata only. We intentionally do NOT orderBy in the query:
    // an equality filter + orderBy on a different field requires a Firestore
    // composite index, and a missing index makes onSnapshot fail silently.
    // Sorting client-side keeps the list working without that dependency.
    const q = query(
        collection(firestore, COLLECTION),
        where('iata', '==', iata)
    );
    return onSnapshot(
        q,
        (snapshot) => {
            const toMs = (ts) => (ts?.toMillis ? ts.toMillis() : new Date(ts).getTime() || 0);
            const archives = snapshot.docs
                .map((d) => ({ id: d.id, ...d.data() }))
                .sort((a, b) => toMs(b.flightDate) - toMs(a.flightDate));
            callback(archives);
        },
        (error) => {
            console.error('[archive-service] subscribeToArchives failed:', error);
            callback([]);
        }
    );
};

export const subscribeToArchive = (archiveId, callback) => {
    const docRef = doc(firestore, COLLECTION, archiveId);
    return onSnapshot(docRef, (d) => {
        if (d.exists()) callback({ id: d.id, ...d.data() });
    });
};

export const deleteArchive = async (archiveId) => {
    const docRef = doc(firestore, COLLECTION, archiveId);
    await deleteDoc(docRef);
};
